import { api } from '../utils/apiClient';

export type SupportCategory =
  | 'benchmark_feedback'
  | 'free_tier'
  | 'bug'
  | 'commercial_license'
  | 'other';

export type SupportSeverity = 'low' | 'medium' | 'high';

export interface SupportRequestPayload {
  category: SupportCategory;
  subject: string;
  message: string;
  requester_email: string;
  severity?: SupportSeverity;
  metadata?: Record<string, unknown>;
}

export interface SupportRequestResponse {
  reference_code: string;
  status: 'received' | string;
  created_at: string;
}

export const createSupportRequest = async (
  payload: SupportRequestPayload
): Promise<SupportRequestResponse> => {
  return api.post<SupportRequestResponse>('/support/requests', payload);
};
